<template>
	<div>
		<div class="jumbotron bg_voice">
			<div class="container">
				<div class="row" style="height: 100px"></div>
			</div>
		</div>
		<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
			<el-tab-pane label="留言互动" name="first">
				<div class="recording_1">
					<div>
						<el-input type="textarea" placeholder="请输入内容" v-model="textarea" maxlength="50" show-word-limit>
						</el-input>
					</div>
					<div style="height: 30px;"></div>
					<samp class="samp_info_bin" @click="data_text()">提交数据</samp>
				</div>

			</el-tab-pane>
			<el-tab-pane label="语音互动" name="second">
				<uploadvoice @upFile="imgages_b" />
			</el-tab-pane>
		</el-tabs>

		<audio ref="audio" :src="audioUrl"></audio>

		<div style="margin-top: 20px;" class="jumbotron_c t_20" v-for="(item,index) in list_1">
			<div style="font-size: 12px; margin-bottom: 10px;">匿名网友：{{dateForma(item.time)}}</div>
			<div v-if="item.key_id==2">{{item.reply}}</div>
			<div v-if="item.key_id==1" @click="data_auto(item.reply)">
				点击播放音频内容
			</div>
		</div>

		<button v-if="count > page * 10" @click="moreShow" class="btn3"
			style="display: block;margin: 15px auto 0; outline: none;color: #666; width: 50%; background-color: #eee; height: 40px;">
			更多数据
		</button>
		<div v-else style="text-align: center; margin-top: 15px">已无更多</div>

		<div style="height: 30px"></div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				audioUrl: "", //声音文件
				page: 0,
				count: 0,
				list_1: [],
				textarea: "",
				activeName: 'first',
			};
		},
		name: 'home',
		methods: {
			imgages_b(path) {
				//this.$set(this.ruleForm, 'imgages_b', path)
				this.updata(path, 1)
			},
			data_text() {
				if (this.textarea.length < 5) {
					this.$Message.error("数据内容不能少于5字！");
					return
				}
				this.updata(this.textarea, 2);
				this.textarea = "";
			},
			//播放声音
			data_auto(url) {
				let audio = new Audio()
				audio.src = url;
				audio.play();
			},
			//更新数据
			updata(path, key) {
				let data = new FormData();
				data.append("reply", path);
				data.append("key_id", key);
				data.append("openid", new Date().getTime());
				this.$api
					.postAPI(
						`mutual/reply/?type_id=20201153`,
						data
					)
					.then((res) => {
						let data = res.data;
						if (data.code == 200) {
							this.$Message.success("上传成功，等待审核！！");
							this.list_1.push({
								"key_id": key,
								"reply": "内容审核中...",
								"time": new Date().getTime()/1000,
							});
						}
						console.log(data);
					});
			},
			//卡片切换动画
			handleClick(tab, event) {
				console.log(tab, event);
			},
			list_data(p) {
				// 点击查询更多
				this.$api
					.getAPI("mutual/reply/?type_id=20201153&state=1", {
						page: p,
					})
					.then((res) => {
						var db = res.data.data.data[0];
						console.log(db);
						this.count = db.page.count;
						this.page = db.page.page;
						for (let i = 0; i < db.models.length; i++) {
							this.list_1.push(db.models[i]);
						}
					});
			},
			//分页数据
			moreShow() {
				var c = this.page * 10;
				if (c < this.count) {
					this.page = this.page + 1;
					this.count = this.page * 10;
					this.list_data(this.page);
				}
			},
			//时间格式转换
			dateForma(timestamp) {
				var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? "0" + MM : MM;
				let d = date.getDate();
				d = d < 10 ? "0" + d : d;
				let h = date.getHours();
				h = h < 10 ? "0" + h : h;
				let m = date.getMinutes();
				m = m < 10 ? "0" + m : m;
				let s = date.getSeconds();
				s = s < 10 ? "0" + s : s;
				return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
			},


		},
		mounted() {
			//默认加载
			this.list_data(1);
		}
	}
</script>



<style scoped>
	.samp_info {
		background: #409EFF;
		padding: 1.5rem 3.5rem;
		border-radius: 5px;
		color: #ffffff;
	}

	.recording {
		padding-top: 30px;
		height: 200px;
		line-height: 70px;
		text-align: center;
	}

	.samp_info_bin {
		background: #409EFF;
		padding: 10px 20px;
		border-radius: 5px;
		color: #ffffff;
		height: 100px;
	}

	.recording_1 {
		height: 120px;
	}

	.jumbotron_c {
		background: #f3f4f8;
		border-radius: 5px;
		padding: 20px;
	}
	.bg_voice {
		background: url("https://img.hsnms.com/20211224/1640308850.jpg") no-repeat center;
		background-size: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/web/bwg/list_interactive.vue